let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1hp0c")).then(() => parcelRequire('5eXru'));